import {createSelector} from 'reselect'
import {selectTaskManagement} from '../selectors'
import TaskManagementStore from "../TaskManagementStore"
import {getDefaultOpenWorkflowStatus} from '../../workflowStatus/selectors'
import {
    getExistingTaskIdsForView,
    getSelectedTaskIdsArray,
    isExistingTaskIdsLoading,
    isPendingSelectAll,
    isTasksLoaded,
} from '../taskSelection/selectors'
import {isBTYEnabled, isTTAEnabled, isURAEnabled} from '../../features/selectors'

const getBulkOperationsPanel = createSelector(
    selectTaskManagement,
    (tm) => tm.bulkOperationsPanel
)

export const isShowPanel = createSelector(
    getSelectedTaskIdsArray,
    isPendingSelectAll,
    (selectedIds, pendingSelectAll) => selectedIds.length > 0 || pendingSelectAll
)

export const getBulkOperationsPanelState = createSelector(
    getSelectedTaskIdsArray,
    getBulkOperationsPanel,
    isExistingTaskIdsLoading,
    getExistingTaskIdsForView,
    isTasksLoaded,
    (selectedTaskIds, bulkOperationsPanel, existingTaskIdsLoading, existingTaskIds, tasksLoaded) => {
        return {
            loading: existingTaskIdsLoading || !tasksLoaded,
            selectedTasksCount: selectedTaskIds.length,
            existingTasksCount: Object.keys(existingTaskIds).length,
        }
    }
)

export const isProcessingBulkOperation = createSelector(
    getBulkOperationsPanel,
    (bulkOperationPanel) => {
        return bulkOperationPanel.operationProcessing
    }
)

export const getBulkOperationProgress = createSelector(
    getBulkOperationsPanel,
    (bulkOperationPanel) => {
        return bulkOperationPanel.operationProgress
    }
)

export const getCurrentOperation = createSelector(
    getBulkOperationsPanel,
    (bulkOperationPanel) => bulkOperationPanel.currentOperation
)

export const getBulkTaskDeleteDialogData = createSelector(
    getBulkOperationsPanel,
    (bulkOperationPanel) => {
        const deleteDialogData = bulkOperationPanel.deleteDialogData
        return {
            ...deleteDialogData,
            otherBlockedTaskCount: deleteDialogData.entitiesBlockedCount - deleteDialogData.entitiesBlocked.length,
            hasManagerApprover: TaskManagementStore.getManagerNeedApproval(),
        }
    }
)

export const getBulkAssignDialogData = createSelector(
    getBulkOperationsPanel,
    isURAEnabled,
    isBTYEnabled,
    isTTAEnabled,
    (bulkOperationsPanel, userRatesEnabled, billingTypesEnabled, timeTrackApprovalEnabled) => ({
        ...bulkOperationsPanel.assignToDialogData,
        userRatesEnabled,
        billingTypesEnabled,
        timeTrackApprovalEnabled,
    })
)

export const getBulkMoveDialogData = createSelector(
    getBulkOperationsPanel,
    (bulkOperationsPanel) => bulkOperationsPanel.moveDialogData
)

export const getBulkChangeStatusDialogData = createSelector(
    getBulkOperationsPanel,
    getDefaultOpenWorkflowStatus,
    (bulkOperationsPanel, defaultStatus) => {
        return {
            ...bulkOperationsPanel.changeStatusDialogData,
            numberOfTasks: bulkOperationsPanel.changeStatusDialogData.taskIds.length,
            defaultWorkflowStatusId: defaultStatus.id
        }
    }
)



// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/selectors.js